export default __webpack_public_path__ + "static/media/dreamhost.dd5299ac.svg";